// PageViewTracker.tsx
import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { pushDL } from "./GoogleAdAnalytics";

export default function GooglePageViewTracker() {
    const location = useLocation();

    useEffect(() => {
        // Push a page_view on every route change
        pushDL("page_view", {
            page_path: location.pathname + location.search,
            page_location: window.location.href,
            page_title: document.title || undefined,
        });
    }, [location]);

    return null;
}